import React from 'react';
import Button from '../button/Button.jsx';
import StepperGen from '../../common/StepperGen/StepperGen.jsx';

const Navbar = ({
  navActive,
  isNextDisabled,
  onContinueClick,
  onBackClick,
  currentStep,
  totalSteps,
  btnText,
  stepperText,
  isLoading,
}) => {
  let barWidth;
  if ((currentStep || currentStep >= 0) && totalSteps) {
    barWidth = currentStep / totalSteps;
  }

  return (
    <nav className="nav">
      <div className={`nav__top ${navActive ? 'active' : ''}`}>
        {navActive && (
          <StepperGen
            currentStep={currentStep}
            totalSteps={totalSteps}
            onBackClick={onBackClick}
            barPercentage={barWidth}
            stepperText={stepperText}
          />
        )}
      </div>

      <div className="nav__progress">
        <div className="bar" style={{ transform: `scaleX(${barWidth})` }}></div>
      </div>

      <div className="nav__container">
        <div className={`nav__content ${navActive ? '' : 'navEnd'}`}>
          {navActive && (
            <StepperGen
              currentStep={currentStep}
              totalSteps={totalSteps}
              onBackClick={onBackClick}
              barPercentage={barWidth}
              stepperText={stepperText}
            />
          )}
          <Button
            primary
            disabled={isNextDisabled}
            onClick={onContinueClick}
            loading={isLoading}
          >
            {btnText || 'Continuar'}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
